import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { getAssetPath } from '../utils/assetHelper';
import './SettingsDisplayPage.scss';

interface LanguageOption {
  value: string;
  label: string;
}

interface CurrencyOption {
  value: string;
  label: string;
}

const SettingsDisplayPage: React.FC = () => {
  // State for language and currency
  const [language, setLanguage] = useState('English');
  const [currency, setCurrency] = useState('USD');

  // Language options
  const languageOptions: LanguageOption[] = [
    { value: 'English', label: 'English' },
    { value: 'Spanish', label: 'Spanish' },
    { value: 'Turkish', label: 'Turkish' }
  ];

  // Currency options
  const currencyOptions: CurrencyOption[] = [
    { value: 'USD', label: 'USD' },
    { value: 'EUR', label: 'EUR' },
    { value: 'TL', label: 'TL' }
  ];

  // Handle language change
  const handleLanguageChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setLanguage(e.target.value);
    
    // In a real app, this would save to backend
    console.log('Language changed to:', e.target.value);
  };

  // Handle currency change
  const handleCurrencyChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setCurrency(e.target.value);
    
    // In a real app, this would save to backend
    console.log('Currency changed to:', e.target.value);
  };

  // Set document title on component mount
  useEffect(() => {
    document.title = 'Settings - Theme & Display | Phantom Clash';
    
    // Initialize tooltips if Bootstrap is available
    if ((window as any).bootstrap) {
      const tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'));
      tooltipTriggerList.map(function(tooltipTriggerEl) {
        return new (window as any).bootstrap.Tooltip(tooltipTriggerEl);
      });
    }
  }, []);

  return (
    <>
      {/* Page Menu */}
      <div className="c-page-menu">
        <ul>
          <li><Link to="/settings-profile">Profile</Link></li>
          <li><Link to="/settings-notifications">Notifications</Link></li>
          <li><Link to="/settings-wallet">Wallet</Link></li>
          <li><Link to="/settings-security">Security</Link></li>
          <li><Link to="/settings-privacy">Privacy</Link></li>
          <li className="active"><Link to="/settings-display">Theme & Display</Link></li>
          <li><Link to="/settings-advanced">Advanced Settings</Link></li>
        </ul>
      </div>

      <div className="d-block w-100">
        <div className="box position-relative z-1 mt-2">
          <div className="c-content-box c-content-box--xspadding overflow-visible c-content-box--setting-width">
            <div className="c-content-box__title">
              <h1 style={{ backgroundImage: 'none' }}><i className="bi bi-display"></i> Theme & Display Preferences</h1>
              <div className="c-content-box__title-info"></div>
            </div>
            <div className="c-content-box__content" style={{ WebkitMaskImage: 'none' }}>
              <h5 className="c-content-mini-title gray">Customize your dashboard experience</h5>
              <h3 className="c-content-mini-title-2 mb-md-4 mb-3">Language & Currency Settings</h3>
              
              {/* Language Selection */}
              <div className="c-input-group mb-4">
                <label htmlFor="language" className="c-form-label c-form-label--gray">Choose your preferred language</label>
                <select 
                  id="language" 
                  data-icon="<i class='bi bi-globe'></i>" 
                  className="c-selectbox w-100"
                  value={language}
                  onChange={handleLanguageChange}
                >
                  {languageOptions.map(option => (
                    <option key={option.value} value={option.value}>{option.label}</option>
                  ))}
                </select>
              </div>
              
              {/* Currency Selection */}
              {/*<div className="c-input-group mb-0">
                <label htmlFor="currency" className="c-form-label c-form-label--gray">Select your preferred currency display</label>
                <select 
                  id="currency" 
                  data-icon="<i class='bi bi-list-ul'></i>" 
                  className="c-selectbox w-100"
                  value={currency}
                  onChange={handleCurrencyChange}
                >
                  {currencyOptions.map(option => (
                    <option key={option.value} value={option.value}>{option.label}</option>
                  ))}
                </select>
              </div>*/}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SettingsDisplayPage; 